export default "assets/section-sparkles-6fe83520.png";